import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 480,
    maxWidth: 560
  },
  hint: {
    marginLeft: 32,
    marginTop: -4,
    marginBottom: 8
  },
  fileField: {
    marginLeft: 32,
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  refusal: {
    color: '#bf2600'
  },
  actions: {
    display: 'flex',
    gap: 12,
    paddingTop: 8
  }
});
export default useStyles;